import { useEffect } from "react";
import { getAutoPlan } from "../../../api";

/** Suit la génération de planning en cours (polling 2,5 s) puis recharge et notifie. */
export const usePlanPolling = (running, setAuto, load, toast) => {
  useEffect(() => {
    if (!running) return undefined;
    const t = setInterval(async () => {
      const r = await getAutoPlan();
      setAuto(r.data);
      if (r.data.running) return;
      load();
      const holidays = r.data.last_holidays ? `, ${r.data.last_holidays} jour(s) férié(s)` : "";
      toast({ title: "Planning généré ✓", description: `${r.data.last_created} intervention(s) créée(s), ${r.data.last_skipped || 0} déjà existante(s)${holidays}.` });
      if (r.data.last_overlaps) toast({ title: `⚠️ ${r.data.last_overlaps} chevauchement(s) détecté(s)`, description: "Un easer a deux interventions en même temps. Consultez la charge hebdomadaire dans l'Agenda (email envoyé au super-admin).", variant: "destructive" });
    }, 2500);
    return () => clearInterval(t);
  }, [running, setAuto, load, toast]);
};
